export const Logo = ({ className = "h-9" }) => (
  <img src="/tark-logo.png" alt="TARK" className={`${className} w-auto`} data-testid="tark-logo" />
);
